export enum InputTypes {
  TEXT = "text",
  NUMBER = "number",
  EMAIL = "email",
  DATE = "date",
  PHONE = "tel",
  TEXTAREA = "textarea",
  SELECT = "select",
  RADIO = "radio",
  CHECKBOX = "checkbox",
}
